import React, { useState } from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  RedditShareButton,
  RedditIcon
} from 'react-share';

const SocialShareBox = ({ url, style = {} }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  const mergedStyles = {
    container: {
      ...defaultStyles.container,
      ...style.container,
    },
    root: {
      ...defaultStyles.root,
      ...style.root,
    },
    title: {
      ...defaultStyles.title,
      ...style.title,
    },
    icons: defaultStyles.icons,
    linkBox: {
      ...defaultStyles.linkBox,
      ...style.copyContainer,
    },
    input: defaultStyles.input,
    copyBtn: defaultStyles.copyBtn,
  };

  return (
    <div style={mergedStyles.root}>
      <div style={mergedStyles.container}>
        <div style={mergedStyles.icons}>
          <FacebookShareButton url={url}>
            <FacebookIcon size={40} round />
          </FacebookShareButton>

          <TwitterShareButton url={url}>
            <TwitterIcon size={40} round />
          </TwitterShareButton>

          <LinkedinShareButton url={url}>
            <LinkedinIcon size={40} round />
          </LinkedinShareButton>

          <RedditShareButton url={url}>
            <RedditIcon size={40} round />
          </RedditShareButton>
        </div>

        <div style={mergedStyles.linkBox}>
          <input
            type="text"
            value={url}
            readOnly
            style={mergedStyles.input}
          />
          <button onClick={handleCopy} style={mergedStyles.copyBtn}>
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SocialShareBox;

const defaultStyles = {
  root: {
    background: '#f5f5f5',
    padding: 20,
    borderRadius: 12,
    textAlign: 'center',
    fontFamily: 'sans-serif',
  },
  container: {
    padding: 15,
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 16,
  },
  icons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: 20,
  },
  linkBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '6px',
    padding: '8px 12px',
    overflow: 'hidden',
  },
  input: {
    flex: 1,
    backgroundColor: 'transparent',
    border: 'none',
    color: '#fff',
    fontSize: '14px',
    outline: 'none',
  },
  copyBtn: {
    background: 'none',
    color: '#4f9eff',
    border: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    marginLeft: '12px',
  },
};